import React, { useEffect, useState } from 'react';
import './CircularTimer.css';

function CircularTimer({ duration, timeLeft }) {
  const radius = 45;
  const circumference = 2 * Math.PI * radius;
  const progress = (timeLeft / duration) * 100;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  const minutes = Math.floor(timeLeft / 60).toString().padStart(2, '0');
  const seconds = (timeLeft % 60).toString().padStart(2, '0');
  const displayTime = `${minutes}:${seconds}`;

  let ringColor = '#339af0'; // default blue
  if (timeLeft <= 300 && timeLeft > 60) ringColor = '#fd7e14'; // orange (5 min)
  else if (timeLeft <= 60) ringColor = '#d6336c'; // red (1 min)

  const isBlinking = timeLeft <= 300; // Blink alert when <= 5 minutes


  return (
    <div className="circular-timer" title={`Remaining Time: ${displayTime}`}>
      <svg width="120" height="120">
        <circle
          cx="60"
          cy="60"
          r={radius}
          stroke="#e9ecef"
          fill="none"
          strokeWidth="10"
        />
        <circle
          cx="60"
          cy="60"
          r={radius}
          stroke={ringColor}
          fill="none"
          strokeWidth="10"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          className={`progress-ring ${isBlinking ? 'blinking' : ''}`}
        />
        <text x="50%" y="50%" textAnchor="middle" dy=".3em" className="timer-text">
          {/* {Math.floor(timeLeft / 60)}:{(timeLeft % 60).toString().padStart(2, '0')} */}
          {displayTime}
        </text>
      </svg>
    </div>
  );
}

export default CircularTimer;
